import { render, staticRenderFns } from "./folder-card.vue?vue&type=template&id=5b0d85c6&scoped=true&"
import script from "./folder-card.vue?vue&type=script&lang=js&"
export * from "./folder-card.vue?vue&type=script&lang=js&"
import style0 from "./folder-card.vue?vue&type=style&index=0&id=5b0d85c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d85c6",
  null
  
)

export default component.exports